export const runScript = async (url : string) => {
	return new Promise((resolve, reject) => {
		const script = document.createElement('script');
		script.src = url;
		script.onload = resolve;
		script.onerror = reject;

		const firstScript = document.getElementsByTagName('script')[0];
        if(firstScript && firstScript.parentNode)
		    firstScript.parentNode.insertBefore(script, firstScript);
	});
};

export const matchingPathname = (pathnames: any) => (location : any) => pathnames.some((pathname: any) => location.pathname === pathname);